import { render, staticRenderFns } from "./AccountReservationsList.vue?vue&type=template&id=29c86a0c&"
import script from "./AccountReservationsList.vue?vue&type=script&lang=js&"
export * from "./AccountReservationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports